export const heroVideo = () => {
  $('.hero-video').click(function () {
    function youtube_parser(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }
    var videoSrc = $('div', this).text().trim().slice(1, -1);
    //console.log(videoSrc));

    $('.site-content').append(
      '<div id="biobox" class="video-popup" style="display:none;"><div class="popup-contents" data-scroll-sticky data-scroll-target="#biobox"><a href="#" class="popup-closer">Close</a><iframe width="960" height="540" src="https://www.youtube.com/embed/' +
        youtube_parser(videoSrc) +
        '?autoplay=1" frameborder="0" allowfullscreen  allow="autoplay"></iframe></div></div>'
    );

    $('.video-popup').fadeIn(150);

    $('body').addClass('locked');
  });

  $('body').on('click', '.popup-closer', function () {
    $('.video-popup').remove();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '.video-popup', function () {
    $('.video-popup').remove();
    $('body').removeClass('locked');
    return false;
  });

  $('body').on('click', '.popup-contents', function (e) {
    e.stopPropogation();
  });

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      $('.video-popup').remove();
      $('body').removeClass('locked');
    }
  });
};
